import React, { useRef } from 'react';

import classNames from 'classnames';

import { TOC } from '../TOC';

import * as classes from './style.module.scss';

interface Props {
  title: string;
  imagesLoaded: boolean;
  contentRef: React.MutableRefObject<HTMLDivElement | null>;
  mdxAST: MDXAST;
  className?: string;
}

export const SideSheet: React.FC<Props> = ({
  title,
  contentRef,
  imagesLoaded,
  mdxAST,
  className,
}) => {
  const sideRef = useRef<HTMLAreaElement | null>(null);

  return (
    <aside ref={sideRef} className={classNames(classes.root, className)}>
      <div className={classes.heading}>{title}</div>
      <TOC
        contentRef={contentRef}
        imagesLoaded={imagesLoaded}
        mdxAST={mdxAST}
      />
    </aside>
  );
};
